import { CustomerComponent } from './customer/customer.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ResultSyncCustomerComponent } from './customer/result-sync-customer/result-sync-customer.component';



const routes: Routes = [
  { path: '', component: CustomerComponent },
  {
    path: 'result-sync-customer/:id',
    component: ResultSyncCustomerComponent,
    
    data: {
      breadcrumb: ['breadcrumbs.enterprise_manage', 'breadcrumbs.enterprise_customer'],
      defaultPath: 'home-enterprise'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CustomerRoutingModule { }